import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c99a20ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "head"
};
const _hoisted_2 = { class: "left" };
const _hoisted_3 = { class: "right" };
const _hoisted_4 = {
    key: 1,
    class: "head"
};
const _hoisted_5 = { class: "left" };
const _hoisted_6 = { class: "right" };
import HeaderLogo from '@/materials/atoms/HeaderLogo.vue';
import MenuList from './header/MenuList.vue';
import Menus from './header/Menus.vue';
import LocalSettings from './header/LocalSettings.vue';
import Help from './header/Help.vue';
import UserSettings from './header/UserSettings.vue';
import Sound from './header/Sound.vue';
import Notification from './header/Notification.vue';
import LanguageList from '@/materials/molecules/LanguageList.vue';
import { useStore } from '@/store/store';
import { useSettings } from '@/logics/settings';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean },
        userInfo: null
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const { putUserSettings } = useSettings();
        const changeSound = (value) => {
            store.state.userSettings.isSound = value;
            if (props.isAuth) {
                putUserSettings({
                    isSound: value,
                });
            }
            else {
                localStorage.setItem('cryptos.sound', String(value));
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("header", null, [
                (_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(HeaderLogo)
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(Sound, {
                                class: "sound cursor",
                                "is-sound": _unref(store).state.userSettings.isSound,
                                onClick: changeSound
                            }, null, 8, ["is-sound"]),
                            (props.isAuth)
                                ? (_openBlock(), _createBlock(UserSettings, {
                                    key: 0,
                                    "user-info": props.userInfo
                                }, null, 8, ["user-info"]))
                                : _createCommentVNode("", true),
                            _createVNode(MenuList, {
                                "is-auth": props.isAuth
                            }, null, 8, ["is-auth"])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (!_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(HeaderLogo),
                            _createVNode(Menus, {
                                "is-auth": props.isAuth
                            }, null, 8, ["is-auth"])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            (props.isAuth)
                                ? (_openBlock(), _createBlock(Notification, { key: 0 }))
                                : _createCommentVNode("", true),
                            _createVNode(Sound, {
                                class: "sound cursor",
                                "is-sound": _unref(store).state.userSettings.isSound,
                                onClick: changeSound
                            }, null, 8, ["is-sound"]),
                            _createVNode(LanguageList, {
                                class: "lefts cursor",
                                "is-auth": props.isAuth
                            }, null, 8, ["is-auth"]),
                            (props.isAuth)
                                ? (_openBlock(), _createBlock(UserSettings, {
                                    key: 1,
                                    class: "lefts cursor",
                                    "user-info": props.userInfo
                                }, null, 8, ["user-info"]))
                                : _createCommentVNode("", true),
                            _createVNode(LocalSettings, { class: "lefts cursor" }),
                            _createVNode(Help, { class: "lefts cursor" })
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
